import axios from "axios";
import { ApiResponse } from "@/types/api";

export type UserAgent = {
	browser: Browser;
	device: Device;
	os: OperatingSystem;
};

export type Browser = {
	name: string;
	version: string;
};

export type Device = {
	type: string;
	name: string;
	brand: string;
};

export type OperatingSystem = {
	name: string;
};

export const getUserAgent = async (
	userAgent: string
): Promise<ApiResponse<UserAgent | null>> => {
	try {
		const response = await axios({
			url: `/api/user-agent?userAgent=${userAgent}`,
			method: "GET",
		});

		return {
			data: response.data,
			error: null,
		};
	} catch (e: any) {
		return {
			data: null,
			error: {
				message: "Unable to retrieve user agent data.",
			},
		};
	}
};
